import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import MyProjects from "@/components/MyProjects";
import FunStuff from "@/components/FunStuff";
import AboutMe from "@/components/AboutMe";
import ContactMe from "@/components/ContactMe";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/aboutme",
      name: "AboutMe",
      component: AboutMe
    },
    {
      path: "/contactme",
      name: "ContactMe",
      component: ContactMe
    },
    {
      path: "/myprojects",
      name: "MyProjects",
      component: MyProjects
    },
    {
      path: "/funstuff",
      name: "FunStuff",
      component: FunStuff
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js